import { ConfigProviderProps, ThemeConfig } from 'antd';
import bgBG from 'antd/locale/bg_BG';
import deDE from 'antd/locale/de_DE';
import frFR from 'antd/locale/fr_FR';
import itIT from 'antd/locale/it_IT';
import ltLT from 'antd/locale/lt_LT';
import ltLV from 'antd/locale/lv_LV';
import nlNL from 'antd/locale/nl_NL';
import svSE from 'antd/locale/sv_SE';

import { CyanColour } from '../../styles';

const getAntdLocale = () => {
  const locale = UiText.locale();
  if (locale.startsWith('bg')) {
    return bgBG;
  }
  if (locale.startsWith('de')) {
    return deDE;
  }
  if (locale.startsWith('fr')) {
    return frFR;
  }
  if (locale.startsWith('it')) {
    return itIT;
  }
  if (locale.startsWith('lt')) {
    return ltLT;
  }
  if (locale.startsWith('lv')) {
    return ltLV;
  }
  if (locale.startsWith('sv')) {
    return svSE;
  }
  if (locale.startsWith('nl')) {
    return nlNL;
  }
  return undefined;
};

export default async function (): Promise<ConfigProviderProps> {
  const response = await fetch(`${window.rootDirectory}_branding/css/theme.json`);
  const brandingTheme: ThemeConfig['token'] = response.ok ? await response.json() : {};
  return {
    locale: getAntdLocale(),
    theme: {
      token: { fontSize: 12, colorPrimary: CyanColour, colorInfo: CyanColour, ...brandingTheme },
      components: {
        Tree: {
          indentSize: 20,
          switcherSize: 20,
          titleHeight: 20,
        },
      },
    },
  };
}
